// ABOUTME: Keeps NFC-oriented public screens on supported mobile devices.
// ABOUTME: Allows the administrative setup flow to run in desktop browsers.

import { useState, useEffect } from "react";
import "./DesktopGate.scss";

interface DesktopGateProps {
  children: React.ReactNode;
}

// Detect if user is on a mobile device
function isMobileDevice(): boolean {
  // Check for touch capability
  const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  // Check user agent for mobile keywords
  const mobileKeywords =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileUA = mobileKeywords.test(navigator.userAgent);

  // Check screen width (tablets count as mobile for this app)
  const isSmallScreen = window.innerWidth <= 1024;

  // Consider it mobile if it has touch AND (mobile UA OR small screen)
  return hasTouch && (isMobileUA || isSmallScreen);
}

function isAdminRoute(): boolean {
  return window.location.pathname.startsWith("/admin");
}

export function DesktopGate({ children }: DesktopGateProps) {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    // Check on mount
    setIsMobile(isMobileDevice());

    // Re-check on resize (for responsive dev tools testing)
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Still detecting - show nothing to prevent flash
  if (isMobile === null) {
    return null;
  }

  // Desktop user - show mobile prompt
  if (!isMobile && !isAdminRoute()) {
    return (
      <div className="desktop-gate">
        <div className="desktop-gate__content">
          {/* App icon */}
          <div className="desktop-gate__icon">
            <img src="/icon-192.png" alt="Touchstone" />
          </div>

          {/* Title */}
          <h1 className="desktop-gate__title">Touchstone</h1>

          {/* Message */}
          <p className="desktop-gate__message">
            This app is designed for mobile devices.
          </p>

          {/* Instructions */}
          <div className="desktop-gate__instructions">
            <p>Open this URL on your phone:</p>
            <code className="desktop-gate__url">{window.location.origin}</code>
          </div>
        </div>
      </div>
    );
  }

  // Mobile user - show app
  return <>{children}</>;
}
